import {
  Box,
  Button,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  TextField,
  Typography,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useEffect, useState } from 'react';
import { SessionManager, SessionManagerKey } from '../SessionManager';
import './ConfigPanel.css';


const Local_storage_key = 'envUrls';

const defaultUrls = [
  'https://rms-sso.la-z-boy.com/lazboy',
  'https://rms-dev.la-z-boy.com/lazboy',
  'https://rms-uat.la-z-boy.com/lazboy',
  'https://rms-oat.la-z-boy.com/lazboy',
  'https://rms-pilot.la-z-boy.com/lazboy',
  'https://dev-int.la-z-boy.com/lazboy',
  'https://rmsdealerpilot4.la-z-boy.com/lazboy',
  'https://rmsdealerpilot2.la-z-boy.com/lazboy',
];

function EnvironmentConfigPanel() {
  let sessionManager: SessionManager = new SessionManager();
  const [selectedEnvironment, setSelectedEnvironment] = useState(
    sessionManager.getRMSEnvironment()
  );

  const [newUrl, setNewUrl] = useState('');
  const [envUrls, setEnvUrls] = useState<string[]>([]);

  useEffect(() => {
    const existingUrls = localStorage.getItem(Local_storage_key);
    if(existingUrls){
      setEnvUrls(JSON.parse(existingUrls));
    } else {
      setEnvUrls(defaultUrls)
    }
  }, []);

  useEffect(() => {
    sessionManager.setRMSEnvironment(selectedEnvironment);
  }, [selectedEnvironment]);

  const handleNewUrls = () => {
    const trimmed = newUrl.trim();
    if(trimmed && !envUrls.includes(trimmed)){
      const updated = [...envUrls, trimmed];
      setEnvUrls(updated);
      localStorage.setItem(Local_storage_key, JSON.stringify(updated));
      setNewUrl('');
    }
  }

  const handlDeleteUrl = (url: string) => {
    const updated = envUrls.filter(u => u!==url);
    setEnvUrls(updated);
    localStorage.setItem(Local_storage_key, JSON.stringify(updated));
    if(selectedEnvironment === url){
      setSelectedEnvironment('');
    } 
  }

  const handleReset = () => {
    localStorage.removeItem(Local_storage_key);
    setEnvUrls(defaultUrls);
    const defaultEnv = process.env.REACT_APP_BASE_RMS_URL || defaultUrls[0];
    setSelectedEnvironment(defaultEnv);
    sessionManager.clearKey(SessionManagerKey.RMS_ENVIRONMENT_KEY);
  }

  return (
    <div id="user-container">
      <Typography variant="subtitle1">
        <Grid container direction="column" spacing={2}>
          <Grid item container columnSpacing={1} alignItems="center" sx={{mt: 3}}>
            <Grid item xs={9}>
              <label htmlFor="user-name" id="user-label">
                Environment
              </label>
            </Grid>
            <Grid item xs = {9}>
              <TextField
               // size="small"
                variant="outlined"
                value={newUrl}
                onChange={(e) => setNewUrl(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs = {3}>
              <Button 
                fullWidth
                variant="contained" 
                onClick={handleNewUrls}>
                Add
              </Button>
            </Grid>
          </Grid>

          <Grid item>
            <Box
              sx={{
                border: 1,
                borderColor: '#797979',
                marginTop: '1em',
                height: '18.2em',
              }}
            >
              <List
                sx={{
                  overflow: 'auto',
                  maxHeight: '275px',
                  minHeight: '175px',
                }}
              >
                {envUrls.map((url) => (
                  <ListItem
                    key={url}
                    selected={selectedEnvironment === url}
                    onClick={() => setSelectedEnvironment(url)}
                    secondaryAction={
                      <IconButton 
                          edge="end"
                          onClick={() => handlDeleteUrl(url)}
                          aria-label={`delete-${url}`}>
                        <DeleteIcon />
                      </IconButton>
                    }
                  >
                    <ListItemText
                      primary={url}
                      primaryTypographyProps={{
                        variant: 'body2',
                        style: { whiteSpace: 'normal', overflow: 'hidden' },
                      }}
                    />
                  </ListItem>
                ))}
              </List>
            </Box>
          </Grid>

          <Grid item container justifyContent="flex-end">
            <Button variant="contained" onClick={handleReset}>
              RESET TO DEFAULT
            </Button>
          </Grid>
        </Grid>
      </Typography>
    </div>
  );
}

export default EnvironmentConfigPanel;